<template>
	<div id="topRight">
		<dv-border-box-6>
			<div class="d-flex jc-center" style="position: relative;">
				<div style="width: 20px;position: absolute; left: 0.9rem;top: 0.4rem;font-size: 0.17rem;line-height: 0.2rem;">用能占比</div>
				<div class="pr-5" id="bottomLeftPie" style="width: 4.5rem; height: 1.5rem;"></div>
			</div>
			<div class="d-flex jc-center">
				<indexRightChart ref="indexRightChart" :weekEnergyData='weekEnergyData' />
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import indexRightChart from "@/components/echart/indexRightChart";
	import echartMixins from "@/utils/resizeMixins";
	export default {
		components: {
			indexRightChart,
		},
		data() {
			return {
				chart: null,
				weekEnergyData: []
			};
		},
		mixins: [echartMixins],
		created(){
			this.weekEnergy();
		},
		mounted() {
			
		},
		methods: {
			async weekEnergy() {
				await this.$axios.get("/api/buildings/weekEnergy").then(res => {
					this.weekEnergyData = res.data.data;
					this.draw()
				})
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("bottomLeftPie"),'dark'
				);
				let yesData = this.weekEnergyData[this.weekEnergyData.length - 1]
				let dataPlus = yesData.air + yesData.pump + yesData.cooling
				let dataQue = [(yesData.air/dataPlus)*100, (yesData.pump/dataPlus)*100, (yesData.cooling/dataPlus)*100]

				let option = {
					backgroundColor: 'rgb(255,255,255,0)',//背景色
					tooltip: {
						trigger: 'item'
					},
					title: {
						text: '昨日',
						left: '34%',
						top: 'center',
						textStyle: {
							fontSize: '14',
							fontWeight: 'normal',
							color: '#fff'
						}
					},
					legend: {
						orient: 'vertical',
						left: 'right',
						top: 'center',
						align: 'left'
					},
					series: [{
						name: '昨日',
						type: 'pie',
						radius: ['40%', '60%'],
						center: ['40%', '50%'],
						label: {
							show: false,
							position: 'center'
						},
						// emphasis: {
						// 	label: {
						// 		show: true,
						// 		fontSize: '20',
						// 		fontWeight: 'bold',
						// 		color: '#fff',
						// 		formatter: function(params) {
						// 			return '昨日'
						// 		}
						// 	}
						// },
						labelLine: {
							show: true
						},
						data: [{
								value: yesData.air,
								name: '空调  ' + dataQue[0].toFixed(1) + '%',
								itemStyle: {
									color: '#47E4E5'
								}
							},
							{
								value: yesData.pump,
								name: '水泵  ' + dataQue[1].toFixed(1) + '%',
								itemStyle: {
									color: '#4293F4'
								}
							},
							{
								value: yesData.cooling,
								name: '冷却塔  ' + dataQue[2].toFixed(1) + '%',
								itemStyle: {
									color: '#BEE5FB'
								}
							},
						]
					}]
				};

				this.chart.setOption(option);
			},
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss">
	#topRight {
		height: 4rem;
		width: 5.125rem;
	}
</style>
